<app-split-pane
  storageKey="split.define"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    @if (!defineStore.activeProjectId() || defineStore.loading()) {
      <app-split-pane-vertical storageKey="split.define.left" [initialTopRatio]="0.7">
        <ng-container top>
          <div class="p-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="40%" rounded="8px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block [lines]="6" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block height="44px" width="100%" rounded="10px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
        <ng-container bottom>
          <div class="p-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="30%" rounded="8px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block [lines]="5" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
      </app-split-pane-vertical>
    } @else {
      <app-split-pane-vertical storageKey="split.define.left" [initialTopRatio]="0.7">
        <ng-container top>
          <div class="define-chat-pane">
            @if (canShowGenerateFromRepoButton) {
              <button class="btn btn-sm btn-outline-primary define-repo-generate-btn" type="button" (click)="onGenerateFromRepo()">
                <i class="bi bi-github me-1"></i>
                Generate from repo
              </button>
            }
            <app-chat
              #defineChat
              [conversationId]="defineStore.activeProjectId()"
              [suggestions]="defineSuggestions"
              [context]="defineContext"
              [orchestratorPageContext]="defineOrchestratorContext"
              [initialMessages]="defineStore.chatMessages()"
              (messagesChange)="onChatMessagesChange($event)"
              (messageCreated)="onChatMessageCreated($event)"
              (aiResult)="onAiResult($event)"
              placeholder="Start describing your project..."
            ></app-chat>
          </div>
        </ng-container>
        <ng-container bottom>
          <app-history scopeKey="define.chat"></app-history>
        </ng-container>
      </app-split-pane-vertical>
    }
  </ng-container>

  <ng-container right>
    @if (!defineStore.activeProjectId() || defineStore.loading()) {
      <app-split-pane-vertical storageKey="split.define.right" [initialTopRatio]="0.7">
        <ng-container top>
          <div class="container py-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="22%" rounded="8px"></app-skeleton-block>
              <div class="mt-2"></div>
              <app-skeleton-block height="44px" width="100%" rounded="10px"></app-skeleton-block>

              <div class="mt-3"></div>
              <app-skeleton-block height="14px" width="30%" rounded="8px"></app-skeleton-block>
              <div class="mt-2"></div>
              <app-skeleton-block height="96px" width="100%" rounded="10px"></app-skeleton-block>

              <hr class="my-3" />
              <app-skeleton-block [lines]="6" height="12px" width="100%" rounded="8px" gap="12px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
        <ng-container bottom>
          <div class="p-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="26%" rounded="8px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block [lines]="5" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
      </app-split-pane-vertical>
    } @else {
      <app-split-pane-vertical storageKey="split.define.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="container py-3" (input)="onFormInput()" (keydown.enter)="onEnterToSave($any($event))">
          @if (debugEnabled()) {
            <div class="alert alert-info py-2 small">
              <div class="fw-semibold mb-1">Define debug</div>
              <div><span class="fw-semibold">Store initialized</span>: {{ debugInfo.storeInitialized }}</div>
              <div><span class="fw-semibold">Active projectId</span>: {{ debugInfo.activeProjectId || '—' }}</div>
              <div><span class="fw-semibold">Loaded name</span>: {{ debugInfo.loadedName || '—' }}</div>
              <div><span class="fw-semibold">Loading</span>: {{ debugInfo.loading }}</div>
              <div><span class="fw-semibold">Error</span>: {{ debugInfo.error || '—' }}</div>
            </div>
          }
          @if (defineStore.error()) {
            <div class="alert alert-danger py-2 small">
              {{ defineStore.error() }}
            </div>
          }

          <section class="card p-3 mb-3">
            <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
              <div>
                <h2 class="h5 mb-1">Define</h2>
                <p class="text-muted mb-0">
                  Capture the project scope and baseline goals before architecture and delivery planning.
                </p>
              </div>
              <button
                class="btn btn-sm btn-outline-secondary flex-shrink-0"
                type="button"
                (click)="showDetailedView = !showDetailedView"
                [attr.aria-expanded]="showDetailedView"
              >
                @if (showDetailedView) {
                  <i class="bi bi-chevron-up me-1"></i>Hide detailed view
                } @else {
                  <i class="bi bi-chevron-down me-1"></i>See detailed view
                }
              </button>
            </div>

            @if (showDetailedView) {
              <h3 class="h6 mb-3">Project Definition</h3>
            }
            <div class="row g-3">
              @if (showDetailedView) {
                <div class="col-lg-7">
                  <div class="row g-3">
                    <div class="col-12">
                      <label class="form-label">Project name <span class="text-danger">*</span></label>
                      <input class="form-control" [(ngModel)]="definitionDraft.name" placeholder="e.g. Customer Portal" />
                    </div>
                    <div class="col-12">
                      <label class="form-label">Product type/category <span class="text-danger">*</span></label>
                      <input class="form-control" [(ngModel)]="definitionDraft.domain" placeholder="e.g. Fintech SaaS" />
                    </div>
                    <div class="col-12">
                      <label class="form-label">Target users</label>
                      <textarea class="form-control" rows="3" [(ngModel)]="definitionDraft.targetUsers" placeholder="Describe who this product serves."></textarea>
                    </div>
                    <div class="col-12">
                      <label class="form-label">Primary goals</label>
                      <textarea class="form-control" rows="4" [(ngModel)]="primaryGoalsText" placeholder="One goal per line..."></textarea>
                    </div>
                  </div>

                  <div class="mt-3 d-flex gap-2">
                    <button
                      class="btn btn-primary"
                      type="button"
                      (click)="saveDefinition()"
                      [disabled]="saving"
                    >
                      @if (saving) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Saving...
                      } @else {
                        Save Definition
                      }
                    </button>
                  </div>

                  @if (definitionValidationError) {
                    <div class="alert alert-danger mt-3 mb-0">{{ definitionValidationError }}</div>
                  }
                </div>
              }

              <div [class.col-lg-5]="showDetailedView" [class.col-12]="!showDetailedView">
                <div class="define-summary-panel">
                  <div class="fw-500 mb-2">Definition Summary</div>
                  <div class="small mb-2">
                    <div class="summary-label">Project</div>
                    <div class="summary-value">{{ definitionDraft.name.trim() || 'Not provided yet' }}</div>
                  </div>
                  <div class="small mb-2">
                    <div class="summary-label">Product type</div>
                    <div class="summary-value">{{ (definitionDraft.domain || '').trim() || 'Not provided yet' }}</div>
                  </div>
                  <div class="small mb-2">
                    <div class="summary-label">Target users</div>
                    <div class="summary-value">{{ (definitionDraft.targetUsers || '').trim() || 'Not provided yet' }}</div>
                  </div>
                  <div class="small">
                    <div class="summary-label">Primary goals</div>
                    @if (definitionDraft.goals.length === 0) {
                      <div class="summary-value">No goals listed yet</div>
                    } @else {
                      <ul class="mb-0 ps-3">
                        @for (goal of definitionDraft.goals; track goal) {
                          <li class="summary-value">{{ goal }}</li>
                        }
                      </ul>
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>

          @if (showDetailedView) {
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Budget (optional)</label>
              <input class="form-control" [(ngModel)]="definitionDraft.budget" placeholder="e.g. $20k / month, 6 weeks" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Team size (optional)</label>
              <input class="form-control" [(ngModel)]="definitionDraft.teamSize" placeholder="e.g. 2 FE, 1 BE, 1 QA" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Timeline (optional)</label>
              <input class="form-control" [(ngModel)]="definitionDraft.timeline" placeholder="e.g. MVP in 4 weeks, V1 in 8 weeks" />
            </div>
            <div class="col-12">
              <label class="form-label">Description</label>
              <textarea class="form-control" rows="4" [(ngModel)]="definitionDraft.description" placeholder="What are we building?"></textarea>
            </div>
          </div>

          <hr class="my-3" />

          <div class="row g-3">
            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Success criteria</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['successCriteria']" placeholder="Add a measurable outcome..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('successCriteria')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.successCriteria; track i; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('successCriteria', i)">Remove</button>
                    </li>
                  }
                </ul>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Goals</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['goals']" placeholder="Add a goal..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('goals')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.goals; track i; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('goals', i)">Remove</button>
                    </li>
                  }
                </ul>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Features</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['features']" placeholder="Add a feature..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('features')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.features; track x; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('features', i)">Remove</button>
                    </li>
                  }
                </ul>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Constraints</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['constraints']" placeholder="Add a constraint (budget, timeline, tech)..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('constraints')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.constraints; track x; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('constraints', i)">Remove</button>
                    </li>
                  }
                </ul>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Stakeholders</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['stakeholders']" placeholder="Add a stakeholder..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('stakeholders')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.stakeholders; track x; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('stakeholders', i)">Remove</button>
                    </li>
                  }
                </ul>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Assumptions</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['assumptions']" placeholder="Add an assumption..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('assumptions')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.assumptions; track x; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('assumptions', i)">Remove</button>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>

          <hr class="my-3" />

          <div class="card p-3 mb-3">
            <div class="fw-500 mb-2">Non-functional requirements</div>
            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label">Performance</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.nonFunctionalRequirements.performance" placeholder="Latency, throughput, page load targets..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">Scalability</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.nonFunctionalRequirements.scalability" placeholder="Expected load, scaling approach..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">Availability / SLA</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.nonFunctionalRequirements.availability" placeholder="Uptime targets, RTO/RPO..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">Security</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.nonFunctionalRequirements.security" placeholder="Threat model, auth requirements, OWASP..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">Privacy</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.nonFunctionalRequirements.privacy" placeholder="PII/PHI handling, retention, deletion..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">Compliance</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.nonFunctionalRequirements.compliance" placeholder="SOC2, GDPR, HIPAA, etc..."></textarea>
              </div>
              <div class="col-md-12">
                <label class="form-label">Accessibility</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.nonFunctionalRequirements.accessibility" placeholder="WCAG targets, keyboard nav, screen readers..."></textarea>
              </div>
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Personas</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['personas']" placeholder="Add a persona (e.g. Admin, Customer, Support agent)..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('personas')">Add</button>
                </div>
                @if (definitionDraft.personas.length === 0) {
                  <div class="text-muted small">No personas added yet.</div>
                } @else {
                  <ul class="small mb-0">
                    @for (x of definitionDraft.personas; track i; let i = $index) {
                      <li class="d-flex justify-content-between align-items-center gap-2">
                        <span>{{ x }}</span>
                        <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('personas', i)">Remove</button>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">User journeys</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['userJourneys']" placeholder="Add a flow (e.g. Sign up → Onboard → Checkout)..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('userJourneys')">Add</button>
                </div>
                @if (definitionDraft.userJourneys.length === 0) {
                  <div class="text-muted small">No user journeys added yet.</div>
                } @else {
                  <ul class="small mb-0">
                    @for (x of definitionDraft.userJourneys; track i; let i = $index) {
                      <li class="d-flex justify-content-between align-items-center gap-2">
                        <span>{{ x }}</span>
                        <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('userJourneys', i)">Remove</button>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">In scope</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['inScope']" placeholder="Add an in-scope item..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('inScope')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.inScope; track x; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('inScope', i)">Remove</button>
                    </li>
                  }
                </ul>
                @if (definitionDraft.inScope.length === 0) {
                  <div class="text-muted small">No in-scope items added yet.</div>
                }
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Out of scope</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['outOfScope']" placeholder="Add an out-of-scope item..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('outOfScope')">Add</button>
                </div>
                <ul class="small mb-0">
                  @for (x of definitionDraft.outOfScope; track x; let i = $index) {
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <span>{{ x }}</span>
                      <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('outOfScope', i)">Remove</button>
                    </li>
                  }
                </ul>
                @if (definitionDraft.outOfScope.length === 0) {
                  <div class="text-muted small">No out-of-scope items added yet.</div>
                }
              </div>
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Risks</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['risks']" placeholder="Add a risk..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('risks')">Add</button>
                </div>
                @if (definitionDraft.risks.length === 0) {
                  <div class="text-muted small">No risks added yet.</div>
                } @else {
                  <ul class="small mb-0">
                    @for (x of definitionDraft.risks; track x; let i = $index) {
                      <li class="d-flex justify-content-between align-items-center gap-2">
                        <span>{{ x }}</span>
                        <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('risks', i)">Remove</button>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="card p-3">
                <div class="fw-500 mb-2">Milestones / phases</div>
                <div class="d-flex gap-2 mb-2">
                  <input class="form-control" [(ngModel)]="addInputs['milestones']" placeholder="Add a milestone (e.g. MVP, Beta, Launch)..." />
                  <button class="btn btn-outline-primary" type="button" (click)="addToList('milestones')">Add</button>
                </div>
                @if (definitionDraft.milestones.length === 0) {
                  <div class="text-muted small">No milestones added yet.</div>
                } @else {
                  <ul class="small mb-0">
                    @for (x of definitionDraft.milestones; track x; let i = $index) {
                      <li class="d-flex justify-content-between align-items-center gap-2">
                        <span>{{ x }}</span>
                        <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('milestones', i)">Remove</button>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>

          <div class="card p-3 mb-3">
            <div class="fw-500 mb-2">Release plan</div>
            <textarea class="form-control" rows="4" [(ngModel)]="definitionDraft.releasePlan" placeholder="MVP vs V1 vs V2, milestones, timeline, deliverables..."></textarea>
          </div>

          <div class="card p-3 mb-3">
            <div class="fw-500 mb-2">Integrations</div>
            <div class="d-flex gap-2 mb-2">
              <input class="form-control" [(ngModel)]="addInputs['integrations']" placeholder="Add an integration (e.g. Stripe, Auth0, Salesforce)..." />
              <button class="btn btn-outline-primary" type="button" (click)="addToList('integrations')">Add</button>
            </div>
            @if (definitionDraft.integrations.length === 0) {
              <div class="text-muted small">No integrations added yet.</div>
            } @else {
              <div class="d-flex flex-wrap gap-2">
                @for (x of definitionDraft.integrations; track x; let i = $index) {
                  <span class="badge bg-secondary">
                    {{ x }}
                    <button class="btn btn-sm btn-link p-0 ms-1 text-white" type="button" (click)="removeFromList('integrations', i)">×</button>
                  </span>
                }
              </div>
            }
          </div>

          <div class="card p-3 mb-3">
            <div class="fw-500 mb-2">Environments & deployment</div>
            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label">Hosting target</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.environmentsAndDeployment.hosting" placeholder="AWS/GCP/Azure/Vercel/on-prem..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">CI/CD</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.environmentsAndDeployment.cicd" placeholder="Pipelines, environments, approvals..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">Environments</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.environmentsAndDeployment.environments" placeholder="Dev/Staging/Prod, feature flags..."></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-label">Observability</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.environmentsAndDeployment.observability" placeholder="Logs, metrics, traces, alerting..."></textarea>
              </div>
              <div class="col-12">
                <label class="form-label">Backups / disaster recovery</label>
                <textarea class="form-control" rows="2" [(ngModel)]="definitionDraft.environmentsAndDeployment.backups" placeholder="Backups, retention, restores, DR plan..."></textarea>
              </div>
            </div>
          </div>

          <div class="card p-3 mb-3">
            <div class="fw-500 mb-2">Permissions / roles model</div>
            <textarea class="form-control" rows="4" [(ngModel)]="definitionDraft.permissionsAndRoles" placeholder="RBAC rules, roles, what each role can do..."></textarea>
          </div>

          <div class="card p-3 mb-3">
            <div class="fw-500 mb-2">Testing strategy</div>
            <textarea class="form-control" rows="4" [(ngModel)]="definitionDraft.testingStrategy" placeholder="Unit/integration/e2e, performance testing, security testing..."></textarea>
          </div>

          <div class="card p-3 mb-3">
            <div class="fw-500 mb-2">UX / UI notes</div>
            <textarea class="form-control mb-2" rows="4" [(ngModel)]="definitionDraft.uxNotes" placeholder="Design system, responsiveness, branding, key interactions..."></textarea>
            <div class="fw-500 mb-2">Key screens</div>
            <div class="d-flex gap-2 mb-2">
              <input class="form-control" [(ngModel)]="addInputs['keyScreens']" placeholder="Add a screen (e.g. Dashboard, Settings, Checkout)..." />
              <button class="btn btn-outline-primary" type="button" (click)="addToList('keyScreens')">Add</button>
            </div>
            @if (definitionDraft.keyScreens.length === 0) {
              <div class="text-muted small">No key screens added yet.</div>
            } @else {
              <ul class="small mb-0">
                @for (x of definitionDraft.keyScreens; track x; let i = $index) {
                  <li class="d-flex justify-content-between align-items-center gap-2">
                    <span>{{ x }}</span>
                    <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeFromList('keyScreens', i)">Remove</button>
                  </li>
                }
              </ul>
            }
          </div>
          }

          <div class="card p-3 mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="fw-500">Models (entities)</div>
              <button class="btn btn-sm btn-outline-primary" type="button" (click)="addModel()">
                <i class="bi bi-plus-lg me-1"></i>Add model
              </button>
            </div>
            <div class="row g-2 mb-2">
              <div class="col-md-4">
                <input class="form-control" [(ngModel)]="newModel.name" placeholder="Model name (e.g. User)" />
              </div>
              <div class="col-md-8">
                <input class="form-control" [(ngModel)]="newModel.description" placeholder="What does it represent?" />
              </div>
              <div class="col-12">
                <div class="d-flex gap-2">
                  <input class="form-control" [(ngModel)]="addInputs['modelField']" placeholder="Add field (e.g. email: string)" />
                  <button class="btn btn-outline-secondary define-inline-btn" type="button" (click)="addModelField()">Add field</button>
                </div>
                <div class="mt-2 d-flex flex-wrap gap-2">
                  @for (f of (newModel.fields || []); track f; let i = $index) {
                    <span class="badge bg-secondary">
                      {{ f }}
                      <button class="btn btn-sm btn-link p-0 ms-1 text-white" type="button" (click)="removeModelField(i)">×</button>
                    </span>
                  }
                </div>
              </div>
            </div>

            @if (definitionDraft.models.length === 0) {
              <div class="text-muted small">No models added yet.</div>
            } @else {
              <div class="table-responsive">
                <table class="table table-sm align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Fields</th>
                      <th class="text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (m of definitionDraft.models; track m.name; let i = $index) {
                      <tr>
                        <td class="fw-500">{{ m.name }}</td>
                        <td class="text-muted small">{{ m.description || '—' }}</td>
                        <td class="text-muted small">{{ formatModelFields(m.fields) || '—' }}</td>
                        <td class="text-end">
                          <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeModel(i)">Remove</button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>

          @if (showDetailedView) {
          <div class="card p-3 mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="fw-500">Services</div>
              <button class="btn btn-sm btn-outline-primary" type="button" (click)="addService()">
                <i class="bi bi-plus-lg me-1"></i>Add service
              </button>
            </div>
            <div class="row g-2 mb-2">
              <div class="col-md-4">
                <input class="form-control" [(ngModel)]="newService.name" placeholder="Service name (e.g. AuthService)" />
              </div>
              <div class="col-md-8">
                <input class="form-control" [(ngModel)]="newService.description" placeholder="What does it do?" />
              </div>
              <div class="col-12">
                <div class="d-flex gap-2">
                  <input class="form-control" [(ngModel)]="addInputs['serviceEndpoint']" placeholder="Add endpoint (e.g. POST /login)" />
                  <button class="btn btn-outline-secondary define-inline-btn" type="button" (click)="addServiceEndpoint()">Add endpoint</button>
                </div>
                <div class="mt-2 d-flex flex-wrap gap-2">
                  @for (e of (newService.endpoints || []); track e; let i = $index) {
                    <span class="badge bg-secondary">
                      {{ e }}
                      <button class="btn btn-sm btn-link p-0 ms-1 text-white" type="button" (click)="removeServiceEndpoint(i)">×</button>
                    </span>
                  }
                </div>
              </div>
            </div>

            @if (definitionDraft.services.length === 0) {
              <div class="text-muted small">No services added yet.</div>
            } @else {
              <div class="table-responsive">
                <table class="table table-sm align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Endpoints</th>
                      <th class="text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (s of definitionDraft.services; track s.name; let i = $index) {
                      <tr>
                        <td class="fw-500">{{ s.name }}</td>
                        <td class="text-muted small">{{ s.description || '—' }}</td>
                        <td class="text-muted small">{{ formatServiceEndpoints(s.endpoints) || '—' }}</td>
                        <td class="text-end">
                          <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeService(i)">Remove</button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>

          <div class="card p-3 mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="fw-500">Components</div>
              <button class="btn btn-sm btn-outline-primary" type="button" (click)="addComponent()">
                <i class="bi bi-plus-lg me-1"></i>Add component
              </button>
            </div>
            <div class="row g-2 mb-2">
              <div class="col-md-4">
                <input class="form-control" [(ngModel)]="newComponent.name" placeholder="Component name (e.g. CheckoutForm)" />
              </div>
              <div class="col-md-8">
                <input class="form-control" [(ngModel)]="newComponent.description" placeholder="What does it do?" />
              </div>
            </div>

            @if (definitionDraft.components.length === 0) {
              <div class="text-muted small">No components added yet.</div>
            } @else {
              <div class="table-responsive">
                <table class="table table-sm align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th class="text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (c of definitionDraft.components; track c.name; let i = $index) {
                      <tr>
                        <td class="fw-500">{{ c.name }}</td>
                        <td class="text-muted small">{{ c.description || '—' }}</td>
                        <td class="text-end">
                          <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeComponent(i)">Remove</button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>

          <div class="card p-3">
            <div class="fw-500 mb-2">Architecture notes</div>
            <textarea class="form-control" rows="5" [(ngModel)]="definitionDraft.architectureNotes" placeholder="High-level architecture, integrations, key decisions..."></textarea>
          </div>
          }
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="define.definition"></app-history>
      </ng-container>
    </app-split-pane-vertical>
    }
  </ng-container>
</app-split-pane>

<!-- Floating actions live OUTSIDE split panes to avoid scroll/overflow interference -->
<ng-template #continueChecklistTpl>
  <div class="small">
    <div class="fw-semibold mb-2">Ready for DB Design?</div>
    <div class="d-flex flex-column gap-1">
      @for (item of continueChecklistItems; track item.key) {
        <div class="d-flex align-items-start gap-2">
          @if (item.done) {
            <i class="bi bi-check-circle-fill text-success"></i>
          } @else {
            <i class="bi bi-circle text-muted"></i>
          }
          <div class="flex-grow-1">
            <div class="fw-500">{{ item.label }}</div>
            @if (!item.done && item.hint) {
              <div class="text-muted">{{ item.hint }}</div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<div class="define-fab-stack">
  @if (hasUnsavedChanges()) {
    <button
      class="btn btn-primary shadow-lg define-fab-btn"
      type="button"
      (click)="saveDefinition()"
      [disabled]="saving"
      aria-label="Save project definition"
    >
      @if (saving) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="fab-label">Saving…</span>
      } @else {
        <i class="bi bi-save"></i>
        <span class="fab-label">Save</span>
      }
    </button>
  }

  <!-- Tooltip is on wrapper so it works even when the button is disabled -->
  <span
    [ngbTooltip]="continueChecklistTpl"
    [tooltipClass]="'define-fab-tooltip'"
    placement="top"
    triggers="hover"
    container="body"
  >
    <button
      type="button"
      class="btn btn-success shadow-lg define-fab-btn"
      [class.is-disabled]="!canContinueToTickets"
      [disabled]="!canContinueToTickets"
      (click)="onContinueToTickets()"
      aria-label="Continue to DB Design"
    >
      <i class="bi bi-diagram-3"></i>
      <span class="fab-label">Ready for DB Design</span>
    </button>
  </span>
</div>
